import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
@Component({
    selector: 'app-cais',
    imports: [RouterOutlet],
    templateUrl: './cais.component.html',
    styleUrls: ['./cais.component.scss']
})
export class CaisComponent implements OnInit {

  constructor() { }


  ngOnInit() {
  }

}
